<script setup lang="ts">
import { capitalize, debounce } from 'lodash'
import { ref, watch } from 'vue'
import { useExtendedI18n } from '@/i18n'
import { VTable, VLoading } from '@/modules/shared/components'
import { ManageEntities } from '../types'

const props = defineProps<{
  entities: ManageEntities[]
  skeleton: boolean
}>()

const { t } = useExtendedI18n()
</script>

<template>
  <div class="mb-5 mt-5 text-xs"></div>
  <VTable
    ref="table"
    :columns="[
      {
        key: 'group_name',
        name: capitalize(t('shared.group')),
        type: 'string',
        is_visible: true,
      },
      {
        key: 'entity_name',
        name: capitalize('name'),
        type: 'string',
        is_visible: true,
      },
      {
        key: 'date_established',
        name: capitalize(t('shared.date established')),
        type: 'date',
        is_visible: true,
      },
      {
        key: 'date_added',
        name: capitalize(t('shared.date added')),
        type: 'date',
        is_visible: true,
      },
    ]"
    :items="entities"
    name="manage-entities"
    :skeleton="!entities || entities.length === 0"
    :slots="['group_name']"
  >
    <template #group_name="{ item }">
      <div>
        <RouterLink
          class="hyperlink font-medium text-blue-700 hover:underline"
          :to="{
            name: 'dashboard',
            params: {
              slug: item.group_subdomain,
            },
          }"
        >
          {{ item.group_name }}
        </RouterLink>
      </div>
    </template>
    <template #entity_name="{ item }">
      <div>
        <RouterLink
          class="hyperlink font-medium text-blue-700 hover:underline"
          :to="{
            name: 'investing.entity-overview',
            params: {
              entity_id: item.id,
              entity_type: item.entity_type,
              slug: item.group_subdomain,
            },
          }"
        >
          {{ item.entity_name }}
        </RouterLink>
      </div>
    </template>
  </VTable>
</template>
